export default __webpack_public_path__ + "static/media/SM-1114S-REAR.545ea1e6.png";